// extracted by mini-css-extract-plugin
module.exports = {"subscription-explained-wrapper":"_3pDy9","summary":"_2Q_9x","subscription-collection":"_3rV6f"};